import { Box, Skeleton } from "@mui/material";

export default function InfoCellSkeleton() {
  return (
    <Box sx={{ minWidth: "92px" }}>
     
      <Skeleton
        sx={(theme) => ({
          ...theme.nawy.typography.english.variants.body.md.regular,
          width: "150px",
        })}
      />
    </Box>
  );
}
